export const SECTION_HEIGHT = 498;
export const MOBILE_SECTION_HEIGHT = 498;
export const RYP_CTA_HEIGHT = 75;
export const SEARCH_HEIGHT = 0;
